export default function StruckOut({ children, ...props }) {
  return (
    <span style={{ textDecoration: "line-through" }} {...props}>
      {children}
    </span>
  );
}
